import { type MutationHookOptions, useMutation } from "@apollo/client";
import {
  CreatePlatformMutation,
  DeletePlatformsMutation,
  RestorePlatformsMutation,
  UpdatePlatformMutation,
  UpdatePlatformStreamingSettingsMutation,
} from "../graphql/mutations";
import type {
  UpdatePlatformStreamingSettingsMutationType,
  UpdatePlatformStreamingSettingsMutationVariablesType,
} from "@/types/graphql/admin.generated";

/**
 * Хуки для мутаций платформ
 * Базовая entity-логика без UI-специфики
 */

export function useCreatePlatformMutation() {
  return useMutation(CreatePlatformMutation);
}

export function useUpdatePlatformMutation() {
  return useMutation(UpdatePlatformMutation);
}

export function useDeletePlatformsMutation() {
  return useMutation(DeletePlatformsMutation);
}

export function useRestorePlatformsMutation() {
  return useMutation(RestorePlatformsMutation);
}

export function useUpdatePlatformStreamingSettingsMutation(
  options?: MutationHookOptions<
    UpdatePlatformStreamingSettingsMutationType,
    UpdatePlatformStreamingSettingsMutationVariablesType
  >
) {
  return useMutation<
    UpdatePlatformStreamingSettingsMutationType,
    UpdatePlatformStreamingSettingsMutationVariablesType
  >(UpdatePlatformStreamingSettingsMutation, options);
}
